
// export const BASE_URL = "http://localhost:8080/api/";
export const BASE_URL = "https://api.menard-portal.com/api/";
export const UI_URL = "https://menard-portal.com";
export const PAGESEND = 1000000;
export const PAGESTART = 1;
export const CREATE_ASSET = BASE_URL + "assets";
export const GET_LIST_ASSET = BASE_URL + 'assets';
export const GET_BY_ID_ASSET = BASE_URL + 'assets';
export const DELETE_BY_ID_ASSET = BASE_URL + 'assets';
export const UPDATE_BY_ASSET = BASE_URL + 'assets';
export const GET_BY_FAMILYID_ASSET = BASE_URL + 'assets/family';
export const GET_BY_FAMILY_ASSETNAME = BASE_URL + 'assets/familyAsset';
export const GET_BY_FAMILY_ASSET = BASE_URL + 'assets/family/harmony';
export const CREATE_INDENT = BASE_URL + "indent";
export const GET_INDENT = BASE_URL + "indentPrimary";
export const CREATE_INDENTTEMPLATE = BASE_URL + "indentTemplate";
export const DELETE_BY_ID_SERVICE = BASE_URL + 'service/delete';
export const DELETE_BY_ID_INSPECTION = BASE_URL + 'inspection/delete';
export const GET_ASSET = BASE_URL + 'asset';
export const GET_STOCKC = BASE_URL + 'stockcode';
export const GET_STOCKT = BASE_URL + 'stock-transactions';
export const GET_LOGISTICS = BASE_URL + 'logisticsUnique';
export const GET_TIMESHEET = BASE_URL + 'timesheetDistinct';
export const GET_STOCK = BASE_URL + 'stockUnique';
export const GET_SERVICE = BASE_URL + 'serviceReportingDistinct';
export const GET_SERVICETEMPLATE = BASE_URL + 'serviceTemplateUnique';
export const GET_SERVICEASSETMAP = BASE_URL + 'serviceAssetMapUnique';
export const GET_INSPECTION = BASE_URL + 'inspectionReportingDistinct';
export const GET_INSPECTIONTEMPLATE = BASE_URL + 'inspectionTemplateUnique';
export const GET_INSPECTIONASSETMAP = BASE_URL + 'inspectionAssetMapUnique';
export const GET_INDENTS = BASE_URL + 'indentunique';
export const GET_INTERNAL = BASE_URL + 'internal';
export const GET_TOOLS = BASE_URL + 'tools';
export const GET_EXTERNAL = BASE_URL + 'external';
export const FAMILY_MASTER = BASE_URL + "family";
export const ASSET_OWNER = BASE_URL + 'owner';
export const TECHNIQUE_MASTER = BASE_URL + 'technique';
export const COUNTRY_MASTER = BASE_URL + "country";
export const CURRENCY_MASTER = BASE_URL + "currency";
export const CATEGORY_MASTER = BASE_URL + "category";
export const MANUFACTURER_MASTER = BASE_URL + "manufacturer";
export const ROLES_MASTER = BASE_URL + 'auth/allRoles';
export const LOGIN = BASE_URL + "auth/login";
export const PASSWORDRESET = BASE_URL + "auth/passwordReset";
export const UPLOAD_FILE = BASE_URL + 'attachments/upload';
export const USER_MASTER = BASE_URL + 'users';
export const USERPASSRESET_MASTER = BASE_URL + 'userpassreset';
export const STOCK_DETAILS = BASE_URL + 'stockCode';
export const CATEGORY_STOCK = BASE_URL + 'stockCode/category';
export const STOCK_TRANS = BASE_URL + 'stockCode/entry';
export const STOCKCODE_MASTER = BASE_URL + 'stockcode';
export const CODETYPE_MASTER = BASE_URL + 'codeType';
export const CLASSCODE_MASTER = BASE_URL + 'classCode';
export const MODEL_MASTER = BASE_URL + 'model';
export const SERVICETYPE_MASTER = BASE_URL + 'serviceType';
export const INSPECTIONTYPE_MASTER = BASE_URL + 'inspectionType';
export const COSTALLOCATION_MASTER = BASE_URL + 'costAllocation';
export const LOCALSTORE_MASTER = BASE_URL + "store";
export const UNITS_MASTER = BASE_URL + "units";
export const FAULT_MASTER = BASE_URL + "fault";
export const REGION_MASTER = BASE_URL + 'region';
export const STATUS_MASTER = BASE_URL + 'status';
export const TRANSPORT_MASTER = BASE_URL + 'transport';
export const TRANSPORTER_MASTER = BASE_URL + 'transporter';
export const SUPPLIER_MASTER = BASE_URL + 'supplier';
export const TOOLS_MASTER = BASE_URL + 'tools';
export const FAMILYTOOLS_MASTER = BASE_URL + 'family/tools';
export const FAMILYEQUIPEMENT_MASTER = BASE_URL + 'family/equipment';
export const EQUIPMENT_MASTER = BASE_URL + 'equipment';
export const NOTICE_MASTER = BASE_URL + 'notice';
export const TEMPLATECOLUMN_MASTER = BASE_URL + 'templateColumn';
export const TIMESHEET_MASTER = BASE_URL + 'timesheet';
export const INSPECTIONCOLUMN_MASTER = BASE_URL + 'inspectionColumn';
export const PROJECT_MASTER = BASE_URL + 'project';
export const SERVICE_TEMPLATE = BASE_URL + "service";
export const GET_LIST_TEMPLATE_BY_ASSET_ID = BASE_URL + "service/family/";
export const SERVICEASSETMAP_TEMPLATE = BASE_URL + "service/template";
export const SERVICEMAP_TEMPLATE = BASE_URL + "service/asset";
export const CREATE_SERVICETEMPLATE = BASE_URL + "service/template/service";
export const INSPECTIONASSETMAP_TEMPLATE = BASE_URL + "inspection/template";
export const SERVICE_TEMPLATE_COLUMN = BASE_URL + "service/template/column";
export const INSPECTION_TEMPLATE = BASE_URL + "inspection";
export const INSPECTION_TEMPLATE_MASTER = BASE_URL + "columns/inspection";
export const GET_LIST_INSPECTIONTEMPLATE_BY_ASSET_ID = BASE_URL + "inspection/family/";
export const INSPECTIONMAP_TEMPLATE = BASE_URL + "inspection/asset";
export const CREATE_INSPECTIONTEMPLATE = BASE_URL + "inspection/template/inspection";
export const INSPECTION_TEMPLATE_COLUMN = BASE_URL + "inspection/template/column";
export const SERVICE_TEMPLATE_MASTER = BASE_URL + "columns/service";
export const FILE_DOWNLOAD_PREVIEW = BASE_URL + "attachments/download/";
export const DELETE_BY_ID_USER = BASE_URL + 'users';
export const DELETE_BY_ID_MANUFACTURER = BASE_URL + 'manufacturer';
export const DELETE_BY_ID_COUNTRY = BASE_URL + 'country';
export const DELETE_BY_ID_CURRENCY = BASE_URL + 'currency';
export const DELETE_BY_ID_LOCALSTORE = BASE_URL + 'store';
export const DELETE_BY_ID_STOCKCODE = BASE_URL + 'stockCode';
export const DELETE_BY_ID_TECHNIQUE = BASE_URL + 'technique';
export const DELETE_BY_ID_FAMILY = BASE_URL + 'family';
export const DELETE_BY_ID_OWNER = BASE_URL + 'owner';
export const HISTORY = BASE_URL + "history";
export const NOTICE = BASE_URL + "notice";
export const CREATE_FAULT = BASE_URL + "fault";
export const GET_LIST_FAULT = BASE_URL + 'fault';
export const GET_BY_ID_FAULT = BASE_URL + 'fault';
export const DELETE_BY_ID_FAULT = BASE_URL + 'fault';
export const GET_LIST_FAULT_BY_ID = BASE_URL + 'fault/user';
export const GET_PREV_FAULT_BY_ID = BASE_URL + "fault/prev";
export const LOGISTICS_MASTER = BASE_URL + 'logistics';
export const GET_BY_FAMILYID_INTASSET = BASE_URL + 'assets/family/internal';
export const GET_BY_FAMILYID_EXTASSET = BASE_URL + 'assets/family/external';
export const GET_BY_FAMILYID_TOOLASSET = BASE_URL + 'assets/family/tools';
export const GET_BY_FAMILYID_INTLOCAL_ASSET = BASE_URL + 'assets/family/intlocal';
export const GET_BY_FAMILYID_EXTLOCAL_ASSET = BASE_URL + 'assets/family/extlocal';
export const GET_BY_FAMILYID_TOOLSLOCAL_ASSET = BASE_URL + 'assets/family/tools-with-local-code';
export const BACKCHARGE_MASTER = BASE_URL + "charge";



